import React, { useState, useEffect, useContext } from 'react';
import { Dropdown, Button, Menu, Typography } from 'antd';
import './DropdownOwnerships.scss';
import { useOwnership } from '../../../context/OwnershipContext';

const { Text } = Typography;

const DropdownOwnerships = ({
  items = [],
  onSelect = () => {},
  onAddNew = () => {},
  disabled = false,
}) => {
  const { ownershipSelected, setOwnershipSelected } = useOwnership();
  const [selectedLabel, setSelectedLabel] = useState('');

  useEffect(() => {
    if (ownershipSelected) {
      setSelectedLabel(`${ownershipSelected.name} ${ownershipSelected.lastname}`);
    }
  }, [ownershipSelected]);

  const handleClick = ({ key }) => {
    if (key === '__new__') {
      setSelectedLabel('Someone else');
      setOwnershipSelected({ name: 'Someone', lastname: 'else', isNew: true})
      onAddNew();
    } else {
      const selectedItem = items.find(item => item._id === key);
      if (selectedItem) {
        setOwnershipSelected(selectedItem);
        onSelect(selectedItem);
      }
    }
  };

  const menuItems = items.map((item, index) => (
    <Menu.Item 
      key={item._id} 
      className={''}
    >
      <div className="item-row">
        <span>{`${item.name} ${item.lastname}`}</span>
        {item.loans !== undefined && (
          <Text type="secondary" style={{marginLeft: '95px', fontSize: '12px'}}>{item.loans.length} loans</Text>
        )}
      </div>
    </Menu.Item>
  ));

  menuItems.push(
    <Menu.Item key="__new__" className="guarantor-dropdown-add">
      <div className='item-row-new'>+ NEW GUARANTOR</div>
    </Menu.Item>
  );

  const menu = <Menu onClick={handleClick}>{menuItems}</Menu>;

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      disabled={disabled}
      overlayClassName="guarantor-dropdown"
    >
      <Button type="link" className="guarantor-button">
        {selectedLabel || 'Select...'}
      </Button>
    </Dropdown>
  );
};

export default DropdownOwnerships;
